// extracted by mini-css-extract-plugin
export var arrows = "_6f-6";
export var decrementer = "_6f-a";
export var disabled = "_6f-4";
export var error = "_6f-1";
export var hiddenText = "_6f-b";
export var incrementer = "_6f-9";
export var input = "_6f-8";
export var inputWrapper = "_6f-0";
export var leadingIcon = "_6f-c";
export var readonly = "_6f-3";
export var regular = "_6f-7";
export var small = "_6f-5";
export var warning = "_6f-2";